export default "__VITE_ASSET__e9435b20__"